import Budget from './Budget';
import OfferPricingCard from './OfferPricingCard';
import { Offer } from '../types';
import { NumberField } from 'react-admin';
import { useRecordContext, useTranslate } from 'ra-core';
import MoneyField from '../../../components/raExtend/fields/MoneyField';
import LabeledHorizontal from '../../../components/raExtend/labels/LabeledHorizontal';
import ContentWrapper from './ContentWrapper';

function Pricing() {
  const t = useTranslate();
  const offer = useRecordContext<Offer>();
  // todo: Uncomment to enable stats when backend is ready
  // const showStats =
  //   offer?.tab_filter === 'accepted' || offer?.tab_filter === 'ended';
  const showStats = false;

  if (!offer) return null;

  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="col-span-full">
        <Budget showStats={showStats} />
      </div>
      <OfferPricingCard label={t('common.text.pricing_model')}>
        <p className="text-lg font-bold text-foreground">
          {t(`offer.pricing_model.${offer.pricing_model}`, {
            _: t('common.text.unavailable'),
          })}
        </p>
      </OfferPricingCard>
      {offer.rate > 0 && (
        <OfferPricingCard label={t('common.text.action_rate')}>
          <MoneyField<Offer>
            source="rate"
            className="text-lg font-bold text-foreground"
          />
        </OfferPricingCard>
      )}
      {showStats && (
        <>
          <OfferPricingCard label={t('common.text.impressions')}>
            <NumberField<Offer>
              source="impressions"
              className="text-lg font-bold text-foreground"
              emptyText="0"
            />
          </OfferPricingCard>
          <OfferPricingCard label={t('common.text.clicks')}>
            <NumberField<Offer>
              source="clicks"
              className="text-lg font-bold text-foreground"
              emptyText="0"
            />
          </OfferPricingCard>
          <OfferPricingCard label={t('common.text.actions')}>
            <NumberField<Offer>
              source="actions"
              className="text-lg font-bold text-foreground"
              emptyText="0"
            />
          </OfferPricingCard>
        </>
      )}
      {offer.conversion_rate > 0 && (
        <OfferPricingCard label={t('common.text.conversion_rate')}>
          <NumberField<Offer>
            source="conversion_rate"
            variant="h6"
            fontWeight="bold"
            options={{ style: 'percent' }}
          />
        </OfferPricingCard>
      )}
      {offer.pricing_model === 'lead-generation' &&
        offer.lead_data_to_collect && (
          <ContentWrapper className="col-span-full">
            <LabeledHorizontal label={t('common.text.lead_data_to_collect')}>
              <span className="text-sm text-foreground whitespace-pre-line">
                {offer.lead_data_to_collect}
              </span>
            </LabeledHorizontal>
          </ContentWrapper>
        )}
      {offer.po_additional_notes && (
        <ContentWrapper className="col-span-full">
          <LabeledHorizontal label={t('common.text.po_additional_notes')}>
            <span className="text-sm text-foreground">
              {offer.po_additional_notes}
            </span>
          </LabeledHorizontal>
        </ContentWrapper>
      )}
    </div>
  );
}

export default Pricing;
